import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SccClinicComponent } from './scc-clinic.component';
import { ClinicSearchModule } from '../../../../../shared/components/clinic-search/clinic-search.module';

@NgModule({
  declarations: [SccClinicComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ClinicSearchModule
  ],
  exports: [SccClinicComponent]
})
export class SccClinicModule { }
